import { render, staticRenderFns } from "./notice_dispaly.vue?vue&type=template&id=95718e5c"
import script from "./notice_dispaly.vue?vue&type=script&lang=js"
export * from "./notice_dispaly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports